import { render, staticRenderFns } from "./MasrofWithTypeReportPrint.vue?vue&type=template&id=2d126d66&"
import script from "./MasrofWithTypeReportPrint.vue?vue&type=script&lang=js&"
export * from "./MasrofWithTypeReportPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports